<template>
  <div class="control-renderer" :class="{ selected: control.id === selectedId, 'is-container': containerTypes.includes(control.type) }" @click.stop="$emit('select', control.id)">
    <!-- Input --><div v-if="control.type === 'Input'" class="ctrl-wrap"><label class="ctrl-label">{{ control.props.label }} <span v-if="control.props.required" class="req">*</span></label><div v-if="control.props.autobrowse" class="input-with-browse"><input type="text" :placeholder="control.props.placeholder" :readonly="control.props.readonly" :disabled="control.props.disabled" :maxlength="control.props.maxLength" :title="control.props.hint" :class="control.props.className" class="ctrl-field browse-input" :style="{ textAlign: control.props.align || 'left' }" :value="control.props.defaultValue" /><button type="button" class="browse-btn" :disabled="control.props.disabled"><i class="fas fa-search"></i></button></div><input v-else type="text" :placeholder="control.props.placeholder" :readonly="control.props.readonly" :disabled="control.props.disabled" :maxlength="control.props.maxLength" :title="control.props.hint" :class="control.props.className" class="ctrl-field" :style="{ textAlign: control.props.align || 'left' }" :value="control.props.defaultValue" /><span v-if="control.props.iscapital" class="capital-hint">大写：{{ control.props.defaultValue || '--' }}</span><span v-if="control.props.ispercent && control.props.total" class="percent-hint">{{ control.props.total }} → %</span></div>
    <!-- Textarea --><div v-else-if="control.type === 'Textarea'" class="ctrl-wrap"><label class="ctrl-label">{{ control.props.label }} <span v-if="control.props.required" class="req">*</span></label><textarea :placeholder="control.props.placeholder" :rows="control.props.rows || 4" :readonly="control.props.readonly" :disabled="control.props.disabled" :maxlength="control.props.maxLength" :title="control.props.hint" :class="control.props.className" class="ctrl-field"></textarea></div>
    <!-- InputNumber --><div v-else-if="control.type === 'InputNumber'" class="ctrl-wrap"><label class="ctrl-label">{{ control.props.label }}</label><input type="number" :min="control.props.neg ? 0 : control.props.min" :max="control.props.max" :disabled="control.props.disabled" :title="control.props.hint" :class="control.props.className" class="ctrl-field" :style="{ textAlign: control.props.align || 'left' }" :value="control.props.defaultValue" /><span v-if="control.props.separator && control.props.defaultValue" class="num-hint">{{ formatNumber(control.props.defaultValue, control.props.decimal || 0, true) }}</span></div>
    <!-- DatePicker --><div v-else-if="control.type === 'DatePicker'" class="ctrl-wrap"><label class="ctrl-label">{{ control.props.label }}</label><input type="date" :disabled="control.props.disabled" :title="control.props.hint" :class="control.props.className" class="ctrl-field" :value="control.props.defaultValue" :style="{ textAlign: control.props.align || 'left' }" /></div>
    <!-- DateRange --><div v-else-if="control.type === 'DateRange'" class="ctrl-wrap"><label class="ctrl-label">{{ control.props.label }}</label><div class="date-range-unit"><input type="date" :placeholder="control.props.startPlaceholder" :disabled="control.props.disabled" :class="control.props.className" class="ctrl-field dr-input dr-input-start" /><span class="dr-sep">—</span><input type="date" :placeholder="control.props.endPlaceholder" :disabled="control.props.disabled" :class="control.props.className" class="ctrl-field dr-input dr-input-end" /><span v-if="control.props.showTimeInterval" class="dr-interval">0天</span></div></div>
    <!-- TimePicker --><div v-else-if="control.type === 'TimePicker'" class="ctrl-wrap"><label class="ctrl-label">{{ control.props.label }}</label><input type="time" :disabled="control.props.disabled" :title="control.props.hint" :class="control.props.className" class="ctrl-field" :style="{ textAlign: control.props.align || 'left' }" /></div>
    <!-- Select --><div v-else-if="control.type === 'Select'" class="ctrl-wrap"><label class="ctrl-label">{{ control.props.label }}</label><select class="ctrl-field" :multiple="control.props.multiple" :disabled="control.props.disabled" :title="control.props.hint" :class="control.props.className"><option v-if="control.props.prompt" value="">{{ control.props.prompt }}</option><option v-if="control.props.selectbindtable" value="">数据库选项({{ control.props.selectbindtable }})</option><option v-for="(opt, i) in (control.props.options || '').split(',').filter(Boolean)" :key="i">{{ opt.trim() }}</option></select></div>
    <!-- Radio --><div v-else-if="control.type === 'Radio'" class="ctrl-wrap"><label class="ctrl-label">{{ control.props.label }}</label><div class="ctrl-inline" :class="control.props.direction === 'vertical' ? 'vertical' : ''"><label v-for="(opt, i) in (control.props.options || '').split(',').filter(Boolean)" :key="i" class="ctrl-opt"><input type="radio" :name="control.id" /> {{ opt.trim() }}</label></div></div>
    <!-- Checkbox --><div v-else-if="control.type === 'Checkbox'" class="ctrl-wrap"><label class="ctrl-label">{{ control.props.label }}</label><div v-if="control.props.detailck === 'GridCheck' || control.props.detailck === 'GridCheckAll'" class="ctrl-inline"><label class="ctrl-opt"><input type="checkbox" /> 全选/反选</label></div><div v-else class="ctrl-inline" :class="control.props.direction === 'vertical' ? 'vertical' : ''"><label v-for="(opt, i) in (control.props.options || '').split(',').filter(Boolean)" :key="i" class="ctrl-opt"><input type="checkbox" /> {{ opt.trim() }}</label></div></div>
    <!-- TreeSelect --><div v-else-if="control.type === 'TreeSelect'" class="ctrl-wrap"><label class="ctrl-label">{{ control.props.label }} <span v-if="control.props.required" class="req">*</span></label><div class="treeselect-preview"><input type="text" :placeholder="control.props.placeholder" readonly class="ctrl-field" :class="control.props.className" :style="{ textAlign: control.props.align || 'left' }" /><i class="fas fa-tree tree-icon"></i><span class="multi-hint" v-if="control.props.multiple">多选</span></div></div>
    <!-- Label --><div v-else-if="control.type === 'Label'" class="ctrl-wrap"><div :class="['label-text', control.props.labelStyle === 'header' ? 'label-header' : '']" :style="getLabelDivStyle(control)">{{ control.props.content }}</div></div>
    <!-- HyperLink --><div v-else-if="control.type === 'HyperLink'" class="ctrl-wrap"><a :href="control.props.href" :target="control.props.target" class="render-link" :class="{ 'task-link': control.props.linktype === 'TaskLink' }"><i v-if="control.props.linktype === 'TaskLink'" class="fas fa-tasks"></i> {{ control.props.content || '链接' }}</a></div>

    <!-- FileUpload --><div v-else-if="control.type === 'FileUpload'" class="ctrl-wrap"><label class="ctrl-label">{{ control.props.label }}</label><div v-if="control.props.attachmenttype === 'View'" class="picker-btn"><i class="fas fa-file-alt"></i> 查看附件</div><div v-else class="upload-box"><i class="fas fa-cloud-upload-alt"></i> 点击或拖拽上传</div></div>
    <!-- ImageUpload --><div v-else-if="control.type === 'ImageUpload'" class="ctrl-wrap"><label class="ctrl-label">{{ control.props.label }}</label><div class="img-box" :style="{ width: control.props.width + 'px', height: control.props.height + 'px' }"><i class="fas fa-image"></i></div></div>
    <!-- RichText --><div v-else-if="control.type === 'RichText'" class="ctrl-wrap"><label class="ctrl-label">{{ control.props.label }}</label><div class="rt-box" :style="{ height: control.props.height + 'px' }"><i class="fas fa-bold"></i><i class="fas fa-italic"></i><i class="fas fa-underline"></i> 富文本编辑器</div></div>
    <!-- SerialNumber --><div v-else-if="control.type === 'SerialNumber'" class="ctrl-wrap"><label class="ctrl-label">{{ control.props.label }}</label><input type="text" class="ctrl-field" readonly :value="control.props.prefix + '00000001'.slice(0, control.props.length)" /></div>
    <!-- UserPicker --><div v-else-if="control.type === 'UserPicker'" class="ctrl-wrap"><label class="ctrl-label">{{ control.props.label }}</label><div class="picker-btn"><i class="fas fa-user-plus"></i> 选择人员</div></div>
    <!-- DeptPicker --><div v-else-if="control.type === 'DeptPicker'" class="ctrl-wrap"><label class="ctrl-label">{{ control.props.label }}</label><div class="picker-btn"><i class="fas fa-building"></i> 选择部门</div></div>
    <!-- Position --><div v-else-if="control.type === 'Position'" class="ctrl-wrap"><label class="ctrl-label">{{ control.props.label }}</label><div class="picker-btn"><i class="fas fa-briefcase"></i> 选择岗位</div></div>
    <!-- Signature --><div v-else-if="control.type === 'Signature'" class="ctrl-wrap"><label class="ctrl-label">{{ control.props.label }}</label><div class="sig-box" :style="{ width: control.props.width + 'px', height: control.props.height + 'px' }"><i class="fas fa-signature"></i> 签名区</div></div>
    <!-- ScanCode --><div v-else-if="control.type === 'ScanCode'" class="ctrl-wrap"><label class="ctrl-label">{{ control.props.label }}</label><div class="picker-btn"><i class="fas fa-qrcode"></i> 扫码录入</div></div>
    <!-- Formula --><div v-else-if="control.type === 'Formula'" class="ctrl-wrap"><label class="ctrl-label">{{ control.props.label }}</label><input type="text" class="ctrl-field" readonly :placeholder="control.props.formula || '计算结果'" /></div>
    <!-- Seal --><div v-else-if="control.type === 'Seal'" class="ctrl-wrap"><label class="ctrl-label">{{ control.props.label }}</label><div class="picker-btn"><i class="fas fa-stamp"></i> 加盖签章</div></div>
    <!-- Hidden --><div v-else-if="control.type === 'Hidden'" class="ctrl-wrap ctrl-hidden-tag"><i class="fas fa-eye-slash"></i> 隐藏字段</div>

    <!-- Tabs --><div v-else-if="control.type === 'Tabs'" class="ctrl-wrap tabs-designer-wrap"><div class="tabs-bar"><div v-for="(tab, ti) in control.props.tabs" :key="ti" class="tab-tag" :class="{ active: ti === 0 }">{{ tab.title }}</div></div><div class="tabs-content"><ControlRenderer v-for="c in control.props.tabs[0].children" :key="c.id" :control="c" :selected-id="selectedId" @select="$emit('select', $event)" /></div></div>
    <!-- SubTable -->
    <div v-else-if="control.type === 'SubTable'" class="ctrl-wrap">
      <label class="ctrl-label" v-if="control.props.label">{{ control.props.label }}</label>
      <table class="sub-table">
        <thead>
          <tr v-for="(hRow, hi) in subHeaderRows" :key="'hr'+hi">
            <th v-for="(cell, ci) in hRow" :key="'hc'+ci"
              :colspan="cell.colspan" :rowspan="cell.rowspan"
              :style="subColWidthStyle(cell.columns[0])">
              {{ cell.text }}
            </th>
            <th v-if="hasOperationCol && hi === 0" :rowspan="subHeaderRows.length" style="width:80px">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="r in control.props.initRows" :key="'r'+r">
            <td v-for="col in control.props.columns.filter(c => c.type !== '_operation')" :key="col.id" :style="subColWidthStyle(col)">&nbsp;</td>
            <td v-if="hasOperationCol" style="text-align:center;">
              <i v-if="getOperationCol?.props?.operationType?.includes('add')" class="fas fa-plus" style="color:#1890ff;margin-right:4px;"></i>
              <i v-if="getOperationCol?.props?.operationType?.includes('delete')" class="fas fa-times" style="color:#f5222d;"></i>
            </td>
          </tr>
        </tbody>
        <tfoot v-if="hasFooter">
          <tr>
            <td v-for="col in control.props.columns.filter(c => c.type !== '_operation')" :key="'f'+col.id" :style="subColWidthStyle(col)" class="sub-footer-cell">
              <span v-if="col.props.footerType === 'sum'" class="footer-text">合计</span>
              <span v-else-if="col.props.footerType === 'avg'" class="footer-text">平均</span>
              <span v-else-if="col.props.footerType === 'count'" class="footer-text">计数</span>
              <span v-else-if="col.props.footerType === 'text'" class="footer-text">{{ col.props.footerText || '' }}</span>
              <button v-else-if="col.props.footerType === 'button'" class="footer-btn" :class="'btn-'+(col.props.buttontype||'default')">
                {{ col.props.footerText || col.props.text || '按钮' }}
              </button>
            </td>
            <td v-if="hasOperationCol"></td>
          </tr>
        </tfoot>
      </table>
    </div>
    <!-- TableLayout --><div v-else-if="control.type === 'TableLayout'" class="ctrl-wrap"><label class="ctrl-label" v-if="control.props.label">{{ control.props.label }}</label><table class="layout-table"><tr v-for="r in control.props.rows" :key="r"><td v-for="c in control.props.cols" :key="c" class="layout-cell"><ControlRenderer v-for="ch in (control.children || [])" :key="ch.id" :control="ch" :selected-id="selectedId" @select="$emit('select', $event)" /></td></tr></table></div>
    <!-- Divider --><div v-else-if="control.type === 'Divider'" class="ctrl-wrap"><hr class="dv" /></div>
    <!-- Button --><div v-else-if="control.type === 'Button'" class="ctrl-wrap"><button class="btn-render" :class="'btn-' + (control.props.type || 'default') + ' sz-' + (control.props.size || 'medium')">{{ buttontypeLabel(control.props.buttontype) || control.props.text }}</button></div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({ control: { type: Object, required: true }, selectedId: { type: String, default: null } })
defineEmits(['select'])
const containerTypes = ['Tabs', 'SubTable', 'TableLayout']
const buttontypeLabels = { Add: '新增', Delete: '删除', MoveUp: '上移', MoveDown: '下移', MoveToTop: '置顶', MoveToBottom: '置底', Browse: '浏览', BrowseCustom: '自定义浏览' }
function buttontypeLabel(type) { return buttontypeLabels[type] || '' }

const hasOperationCol = computed(() => (props.control?.props?.columns || []).some(c => c.type === '_operation'))
const getOperationCol = computed(() => (props.control?.props?.columns || []).find(c => c.type === '_operation') || null)

// Label div style helper
const getLabelDivStyle = (control) => {
  const p = control.props || {}
  const isHeader = p.labelStyle === 'header'
  const style = {}

  if (isHeader) {
    // 标题头模式：CSS class 提供默认值，仅当显式设置时输出 inline style 覆盖
    if (p.color) style.color = p.color
    if (p.fontSize) style.fontSize = p.fontSize + 'px'
    if (p.align) style.textAlign = p.align
  } else {
    style.fontSize = (p.fontSize || 13) + 'px'
    style.textAlign = p.align || 'left'
    style.color = p.color || '#333'
  }

  if (p.backgroundColor) style.backgroundColor = p.backgroundColor
  if (p.borderRadius !== undefined && p.borderRadius !== '') style.borderRadius = p.borderRadius + 'px'
  if (p.padding) style.padding = p.padding + 'px'
  if (p.bold) style.fontWeight = 'bold'
  if (p.lineHeight) style.lineHeight = p.lineHeight + 'px'
  if (p.boxShadow) style.boxShadow = p.boxShadow
  if (p.letterSpacing) style.letterSpacing = p.letterSpacing + 'px'
  return style
}

function formatNumber(val, decimals, useSeparator) {
  const n = Number(val)
  if (isNaN(n)) return val || ''
  const fixed = n.toFixed(decimals)
  if (!useSeparator) return fixed
  const [intPart, decPart] = fixed.split('.')
  return intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (decPart ? '.' + decPart : '')
}

// ============ SubTable 多级表头 & 列宽 & 尾行 ============
const subHeaderRows = computed(() => {
  const cols = props.control?.props?.columns || []
  // 收集所有 headerLevel 值，确定有几级
  const levels = new Set()
  cols.forEach(c => {
    const lv = c.props?.headerLevel
    levels.add(lv ? Number(lv) : 1)
  })
  const maxLevel = Math.max(...levels, 1)
  const rows = []
  for (let lv = 1; lv <= maxLevel; lv++) rows.push([])

  // 分组：按 headerGroup 路径分组
  // headerGroup = "一级标题" 或 "一级标题/二级标题" 等
  // headerLevel = 该列自身标签在第几级
  // 没有 headerGroup 的列：直接放在最底层，rowspan = maxLevel
  const leafCols = []
  const groupMap = {} // groupPath -> { text, level, children }

  cols.forEach(col => {
    const group = col.props?.headerGroup || ''
    const lv = col.props?.headerLevel ? Number(col.props.headerLevel) : maxLevel
    if (group) {
      // 拆分路径
      const parts = group.split('/').map(s => s.trim()).filter(Boolean)
      // 注册各级分组
      let path = ''
      parts.forEach((part, idx) => {
        const prevPath = path
        path = path ? path + '/' + part : part
        if (!groupMap[path]) {
          groupMap[path] = {
            text: part,
            level: idx + 1,
            parent: prevPath || null,
            children: []
          }
          if (prevPath) groupMap[prevPath].children.push(path)
        }
      })
      // 该列挂在最深层分组下
      const leafGroupPath = path
      if (groupMap[leafGroupPath]) {
        groupMap[leafGroupPath].children.push({ type: 'col', col, level: lv })
      }
    } else {
      leafCols.push({ col, level: lv })
    }
  })

  // 找出根分组（没有 parent 的）
  const rootGroups = Object.entries(groupMap).filter(([_, v]) => !v.parent).map(([k, v]) => ({ key: k, ...v }))

  // 第一级：根分组 + 无 headerGroup 的列
  // 第二级及以下：子分组 + 挂在对应分组下的列

  // 重新组织：按层级构建行
  // 用递归方式填充 rows[level-1]
  // 对于每个分组/列，它在 headerLevel 那一级显示，rowspan = maxLevel - headerLevel + 1

  // 简化算法：
  // rows[0] = 第一级标题
  // rows[1] = 第二级标题
  // ...
  // rows[maxLevel-1] = 最底层（实际列标题）

  // 收集所有"显示单元"：
  // - 分组单元：{ text, level, colspan, rowspan }
  // - 列单元：{ text, level, colspan: 1, rowspan }

  function buildCellGroups(groups, parentLevel) {
    // groups: [{ key, text, level, children }]
    // 返回每个分组在其 level 那一行的 cell 描述，以及递归子分组
    const cells = []
    for (const g of groups) {
      const cellLevel = g.level
      // 计算该分组下的叶子列数
      const leafCount = countLeafColumns(g)
      const rowspan = maxLevel - cellLevel + 1
      cells.push({
        text: g.text,
        colspan: leafCount,
        rowspan,
        level: cellLevel,
        columns: collectLeafColumns(g),
        subCells: buildCellGroups(
          g.children.filter(c => typeof c === 'string').map(k => groupMap[k]),
          cellLevel
        )
      })
    }
    // 也包含直接挂在分组下的列（level 可能 > 分组 level）
    return cells
  }

  function countLeafColumns(g) {
    let count = 0
    for (const child of g.children) {
      if (typeof child === 'string') {
        count += countLeafColumns(groupMap[child])
      } else if (child.type === 'col') {
        count++
      }
    }
    return count
  }

  function collectLeafColumns(g) {
    const result = []
    for (const child of g.children) {
      if (typeof child === 'string') {
        result.push(...collectLeafColumns(groupMap[child]))
      } else if (child.type === 'col') {
        result.push(child.col)
      }
    }
    return result
  }

  // 构建行
  // 第一级：根分组 + 无 group 的列（rowspan = maxLevel）
  const firstRowCells = []
  for (const rg of rootGroups) {
    firstRowCells.push({
      text: rg.text,
      colspan: countLeafColumns(rg),
      rowspan: maxLevel - rg.level + 1,
      level: rg.level,
      columns: collectLeafColumns(rg)
    })
  }
  for (const lc of leafCols) {
    firstRowCells.push({
      text: lc.col.props?.label || lc.col.type,
      colspan: 1,
      rowspan: maxLevel,
      level: 1,
      columns: [lc.col]
    })
  }
  rows[0] = firstRowCells

  // 第 2~maxLevel 级：子分组 + 各分组下的列
  for (let lv = 2; lv <= maxLevel; lv++) {
    const rowCells = []
    // 遍历上一级的 cell，如果 rowspan > 1 说明跨过来了，跳过
    // 否则展开子内容
    const prevRow = rows[lv - 2]
    for (const cell of prevRow) {
      if (cell.rowspan > 1) {
        // 这个 cell 跨到下面了，在这一行不显示
        continue
      }
      // 这个 cell 已经结束，展开它的子内容
      // 子内容就是挂在它下面的分组和列
      const subItems = getSubItems(cell)
      for (const item of subItems) {
        const itemLevel = item.level || lv
        const rowspan = maxLevel - itemLevel + 1
        rowCells.push({
          text: item.text,
          colspan: item.colspan || 1,
          rowspan,
          level: itemLevel,
          columns: item.columns || [item.col]
        })
      }
    }
    rows[lv - 1] = rowCells
  }

  function getSubItems(cell) {
    const items = []
    // 从 groupMap 和 leafCols 中找到属于该 cell 的子项
    // 通过 columns 的 headerGroup 前缀匹配
    const cellText = cell.text
    // 找到该 cell 对应的分组 key
    for (const [key, g] of Object.entries(groupMap)) {
      if (g.text === cellText && g.level === cell.level) {
        // 子分组
        for (const childKey of g.children) {
          if (typeof childKey === 'string' && groupMap[childKey]) {
            const sub = groupMap[childKey]
            items.push({
              text: sub.text,
              colspan: countLeafColumns(sub),
              level: sub.level,
              columns: collectLeafColumns(sub)
            })
          }
        }
        // 直接挂在分组下的列（level > 分组 level）
        for (const child of g.children) {
          if (child.type === 'col') {
            items.push({
              text: child.col.props?.label || child.col.type,
              colspan: 1,
              level: child.level,
              columns: [child.col]
            })
          }
        }
        break
      }
    }
    return items
  }

  return rows
})

const subColWidthStyle = (col) => {
  if (!col) return {}
  const w = col.props?.width
  return w ? { width: w + 'px', minWidth: w + 'px', maxWidth: w + 'px' } : {}
}

const hasFooter = computed(() => {
  const cols = props.control?.props?.columns || []
  return cols.some(c => c.props?.footerType && c.props.footerType !== '')
})
</script>

<style scoped>
.control-renderer { position: relative; border: 2px solid transparent; border-radius: 6px; transition: all 0.15s; min-height: 8px; }
.control-renderer:hover { border-color: #a7f3d0; background: rgba(16,185,129,0.03); }
.control-renderer.selected { border-color: #10b981; background: rgba(16,185,129,0.06); }
.ctrl-wrap { padding: 2px; position: relative; }
.ctrl-label { display: block; font-size: 13px; color: #374151; font-weight: 500; margin-bottom: 4px; }
.req { color: #ef4444; margin-left: 2px; }
.ctrl-field { width: 100%; border: 1px solid #d1d5db; border-radius: 4px; padding: 6px 10px; font-size: 13px; outline: none; background: #fff; box-sizing: border-box; }
.ctrl-field:focus { border-color: #10b981; box-shadow: 0 0 0 2px rgba(16,185,129,0.15); }
textarea.ctrl-field { resize: vertical; min-height: 60px; }
.ctrl-inline { display: flex; gap: 12px; flex-wrap: wrap; }
.ctrl-inline.vertical { flex-direction: column; gap: 6px; }
.ctrl-opt { font-size: 13px; display: flex; align-items: center; gap: 4px; cursor: pointer; }
.switch-track { width: 40px; height: 22px; background: #10b981; border-radius: 11px; position: relative; display: inline-block; }
.switch-thumb { position: absolute; top: 2px; right: 2px; width: 18px; height: 18px; background: #fff; border-radius: 50%; }
.input-group { display: flex; align-items: stretch; }
.input-addon { display: flex; align-items: center; padding: 0 10px; border: 1px solid #d1d5db; border-right: none; border-radius: 4px 0 0 4px; background: #f9fafb; font-size: 13px; color: #6b7280; }
.input-group .ctrl-field { border-radius: 0 4px 4px 0; }
.cascader-arrow { position: absolute; right: 10px; top: 50%; color: #9ca3af; font-size: 12px; pointer-events: none; }
.upload-box { border: 2px dashed #d1d5db; border-radius: 6px; padding: 16px; text-align: center; color: #9ca3af; font-size: 13px; }
.img-box { border: 2px dashed #d1d5db; border-radius: 6px; display: flex; align-items: center; justify-content: center; color: #9ca3af; font-size: 24px; background: #f9fafb; }
.rt-box { border: 1px solid #d1d5db; border-radius: 4px; background: #f9fafb; display: flex; align-items: center; justify-content: center; gap: 8px; color: #9ca3af; font-size: 13px; }
.picker-btn { border: 1px solid #d1d5db; border-radius: 4px; padding: 6px 10px; font-size: 13px; color: #9ca3af; cursor: pointer; display: inline-flex; align-items: center; gap: 6px; }
.sig-box { border: 2px dashed #d1d5db; border-radius: 6px; display: flex; align-items: center; justify-content: center; color: #9ca3af; font-size: 20px; background: #fefce8; }
.write-box { border: 2px dashed #d1d5db; border-radius: 6px; display: flex; align-items: center; justify-content: center; color: #9ca3af; font-size: 20px; background: #fefce8; cursor: crosshair; }
.ctrl-hidden-tag { background: #fef3c7; padding: 4px 10px; border-radius: 4px; font-size: 12px; color: #92400e; display: flex; align-items: center; gap: 6px; }
.container-label { font-size: 13px; color: #374151; font-weight: 500; margin-bottom: 4px; }
.container-body { border: 1px dashed #d1d5db; border-radius: 4px; min-height: 36px; }
fieldset { border: 1px solid #d1d5db; border-radius: 6px; padding: 10px; }
legend { font-size: 13px; font-weight: 500; color: #374151; padding: 0 6px; }
.tabs-bar { display: flex; border-bottom: 2px solid #e5e7eb; gap: 0; }
.tab-tag { padding: 6px 16px; font-size: 13px; cursor: pointer; border-bottom: 2px solid transparent; margin-bottom: -2px; color: #6b7280; }
.tab-tag.active { color: #10b981; border-bottom-color: #10b981; font-weight: 500; }
.tabs-content { padding: 8px; }
.sub-table { width: 100%; border-collapse: collapse; }
.sub-table th, .sub-table td { border: 1px solid #e5e7eb; padding: 4px 8px; font-size: 13px; }
.sub-table th { background: #f9fafb; }
.sub-footer-cell { background: #fefce8 !important; text-align: center; }
.footer-text { font-size: 12px; color: #92400e; font-weight: 500; }
.footer-btn { padding: 2px 10px; border-radius: 3px; border: 1px solid #d1d5db; font-size: 12px; cursor: pointer; background: #fff; }
.footer-btn.btn-primary { background: #10b981; color: #fff; border-color: #10b981; }
.footer-btn.btn-danger { background: #ef4444; color: #fff; border-color: #ef4444; }
.layout-table { width: 100%; border-collapse: collapse; }
.layout-table td { border: 1px dashed #e5e7eb; padding: 8px; vertical-align: top; min-height: 60px; }
.layout-cell { min-height: 40px; }
.dv { border: none; border-top: 1px solid #e5e7eb; margin: 8px 0; }
.btn-render { padding: 7px 20px; border-radius: 4px; border: 1px solid #d1d5db; font-size: 13px; cursor: pointer; background: #fff; }
.btn-render.btn-primary { background: #10b981; color: #fff; border-color: #10b981; }
.btn-render.btn-danger { background: #ef4444; color: #fff; border-color: #ef4444; }
.btn-render.btn-warning { background: #f59e0b; color: #fff; border-color: #f59e0b; }
.btn-render.sz-small { padding: 4px 12px; font-size: 12px; }
.btn-render.sz-large { padding: 10px 28px; font-size: 15px; }
.render-link { color: #10b981; text-decoration: underline; font-size: 13px; }
.render-link.task-link { color: #f59e0b; }
.render-link.task-link i { margin-right: 4px; }
.capital-hint { display: block; font-size: 11px; color: #059669; margin-top: 3px; }
/* DateRange combined unit */
.date-range-unit { display: flex; align-items: center; border: 1px solid #d1d5db; border-radius: 4px; background: #fff; overflow: hidden; }
.dr-input { border: none !important; border-radius: 0 !important; box-shadow: none !important; flex: 1; min-width: 0; }
.dr-input:focus { outline: none; background: #f9fafb; }
.dr-sep { padding: 0 6px; color: #9ca3af; font-size: 14px; flex-shrink: 0; user-select: none; }
.dr-interval { font-size: 11px; color: #6b7280; background: #f3f4f6; padding: 2px 6px; border-radius: 3px; flex-shrink: 0; margin-left: 4px; }
.input-with-browse .browse-input { border-radius: 4px 0 0 4px; border-right: none; flex: 1; }
.browse-btn { border: 1px solid #d1d5db; border-radius: 0 4px 4px 0; background: #f9fafb; padding: 0 10px; cursor: pointer; color: #6b7280; font-size: 13px; display: flex; align-items: center; }
.browse-btn:hover { background: #e5e7eb; border-color: #10b981; color: #10b981; }
.percent-hint { display: block; font-size: 11px; color: #8b5cf6; margin-top: 3px; }
.num-hint { display: block; font-size: 11px; color: #6b7280; margin-top: 3px; }
.treeselect-preview { display: flex; align-items: center; gap: 6px; }
.tree-icon { color: #10b981; font-size: 14px; flex-shrink: 0; }
.multi-hint { font-size: 10px; color: #fff; background: #10b981; padding: 1px 6px; border-radius: 10px; flex-shrink: 0; }
/* Tabs - green theme */
.tabs-designer-wrap { width: 100%; }
.tabs-bar { display: flex; align-items: stretch; background: #e0e7ff; border-radius: 6px 6px 0 0; overflow: hidden; border: 1px solid #b8c9f0; border-bottom: none; }
.tab-tag { padding: 6px 18px; font-size: 12px; cursor: default; color: #4a5568; background: transparent; flex: 1; text-align: center; white-space: nowrap; }
.tab-tag.active { background: #1ab394; color: #fff; font-weight: 500; }
.tabs-content { border: 1px solid #b8c9f0; border-radius: 0 0 6px 6px; padding: 8px; background: #fff; min-height: 40px; }
/* Label 文本控件 */
.label-text { word-break: break-all; }
.label-header { 
  background: rgb(16, 185, 129); 
  color: #fff; 
  text-align: center;
  font-size: 16px;
  line-height: 32px;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  border-radius: 0;
  box-shadow: 20px 0px 0px #d1fae5;
  padding: 0 8px;
}
</style>
